module.exports = __webpack_public_path__ + "img/loading.5af33d7.svg";